import {
  getCustomerStaffList,
  getProfileView,
} from "../../redux/reducers/authSlice";
import catchAsync from "../../utils/catchAsync";

import http from "./http";
export const gettingMyProfileApi = catchAsync(async () => {
  const data = await http.get(`/profile/view`);

  return data;
});
export const updateMyProfileApi = catchAsync(async (values) => {
  const data = await http.patch(`/profile/update`, values?.values);
  if (data?.serverResponse?.code === 200) {
    values?.dispatch(getProfileView());
  }
  // if (data && data.status === 200) {
  //     setSession(data.data.tokens);
  // }
  return data;
});

export const updateeditAddressApi = catchAsync(async (values) => {
  console.log(values, 'valuesData')
  const data = await http.post(
    `/profile/location-update/${values?.cusId}/${values?.locationId}`,
    values?.values
  );
  if (data?.serverResponse?.code === 200) {
    values?.dispatch(getProfileView());
  }
  // if (data && data.status === 200) {
  //     setSession(data.data.tokens);
  // }
  return data;
});

export const updateAddAddressApi = catchAsync(async (values) => {
  console.log(values, 'valuesData')
  const data = await http.post(
    `/profile/location-update/${values?.cusId}/undefined`,
    values?.values
  );
  if (data?.serverResponse?.code === 200) {
    values?.dispatch(getProfileView());
  }
  // if (data && data.status === 200) {
  //     setSession(data.data.tokens);
  // }
  return data;
});

export const updatePreferredListProfileApi = catchAsync(async (values) => {
  const data = await http.post(`/profile/edit-preffred-staffs`, values?.values);
  if (data?.serverResponse?.code === 200) {
    values?.dispatch(getProfileView());
    // values?.dispatch(getCustomerStaffList());
  }
  // if (data && data.status === 200) {
  //     setSession(data.data.tokens);
  // }
  return data;
});

export const getCustomerStaffListApi = catchAsync(async () => {
  const data = await http.get(`/profile/get-customer-staffs`);

  return data;
});

export const deleteAddressApi = catchAsync(async (values) => {
  const data = await http.delete(
    `/profile/location-delete/${values?.cusId}/${values?.locationId}`,

  );
  if (data?.serverResponse?.code === 200) {
    values?.dispatch(getProfileView());
  }
  // if (data && data.status === 200) {
  //     setSession(data.data.tokens);
  // }
  return data;
});

// Change password fro user
export const changePasswordApi = catchAsync(async (values) => {
  const data = await http.post(
    `/profile/change-password`,
    values
  );
  return data;
});
